
































































































































import IOutboundDeliveryNotesDetail from '@/store/models/IOutboundDeliveryNotesDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import moment from 'moment';
@Component({
    components: {
        Snackbar
    }
})
export default class OutboundsNoticeOfLossDeliveryNotesDetailSelector extends Vue {
    searchOutboundDeliveryNotesDetail : string = "";
    selectedOutboundDeliveryNotesDetail : IOutboundDeliveryNotesDetail[] = [];
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Pallet', value: 'palletName' },
        { text: 'Pallet id', value: 'idPallet' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Actions', value: 'actions' }
    ];

    @Prop({ type: Array, required: true })
    OutboundDeliveryNotesDetailList !: IOutboundDeliveryNotesDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop()
    value !: IOutboundDeliveryNotesDetail[];

    editedIndex : number = -1;
    editedItem : IOutboundDeliveryNotesDetail = {
        id: "",
        idOutboundDeliveryNote: "",
        idOutboundDetail: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        idPallet: "",
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        weight: 0,
        bestBeforeDate: new Date(),
        casesLoss: 0,
        language: "",
        idPalletCustomer: "",
        location: "",
        goodCode: ""
    }
    defaultItem : IOutboundDeliveryNotesDetail = {
        id: "",
        idOutboundDeliveryNote: "",
        idOutboundDetail: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        idPallet: "",
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        weight: 0,
        bestBeforeDate: new Date(),
        casesLoss: 0,
        language: "",
        idPalletCustomer: "",
        location: "",
        goodCode: ""
    }
    maxCasesPerPallet : number = 0;

    get formTitle() { return this.editedIndex === -1 ? 'New Outbound Detail Delivery Note Detail' : 'Edit Outbound Detail Delivery Note Detail'; }

    @Watch('value')
    updateSelection(newValue : IOutboundDeliveryNotesDetail[] | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedOutboundDeliveryNotesDetail = [];
        }
    }

    @Watch('selectedOutboundDeliveryNotesDetail')
    onChangeselectedOutboundDeliveryNotesDetail() {
        if (this.selectedOutboundDeliveryNotesDetail.length > 0) {
            this.$emit('input', this.selectedOutboundDeliveryNotesDetail);
        } else {
            this.$emit('input', null);
        }
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }
   
    editOutboundDeliveryNotesDetail (item: any, dbox = true) {
        if (this.selectedOutboundDeliveryNotesDetail.length > 0) {
            this.editedIndex = this.OutboundDeliveryNotesDetailList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.maxCasesPerPallet = this.editedItem.casesPerPallet;
            this.dialog = true;
        }
    }

    saveOutboundDeliveryNotesDetail() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            let index = this.OutboundDeliveryNotesDetailList.findIndex(i => i.idPallet === this.editedItem.idPallet);
            Object.assign(this.OutboundDeliveryNotesDetailList[index], this.editedItem);
            this.close();
        } else {
            this.showMessageWarning("Please, some fields have not passed the validation to be able to save.");
        }
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }
}
